<template>
    <v-main v-if="this.$store.getters.getAccessToken" class="mt-n13">
        <div class="mx-1 mt-1 d-flex d-md-none d-lg-none d-xl-none">
            <v-container fluid>
                <EstimateRows></EstimateRows>
            </v-container>
        </div>
        <div class="mx-1 mt-1 d-flex d-md-none d-lg-none d-xl-none mb-16">
            <v-container fluid>
                <OrderRows></OrderRows>
            </v-container>
        </div>
        <div class="d-none d-md-flex">
            <v-container xs="12" class="px-3 mb-n7" fluid>
                <v-main v-if="hasReminder" class="mt-n16">
                    <v-row>
                        <v-col cols="10">
                            <h2 class="my4"><v-icon>mdi-cards-playing-outline</v-icon> 미리 알림</h2>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <Reminder></Reminder>
                        </v-col>
                    </v-row>

                    <v-divider class="mb-5"></v-divider>
                </v-main>

                <v-row>
                    <v-col cols="12">
                        <EstimateRows></EstimateRows>
                    </v-col>
                </v-row>

                <v-divider class="mt-5 mb-5"></v-divider>

                <v-row class="mb-7">
                    <v-col cols="12">
                        <OrderRows></OrderRows>
                    </v-col>
                </v-row>

                <v-container class="mt-15"></v-container>
            </v-container>
        </div>
    </v-main>
</template>

<script>
import Reminder from '@/components/admin/Reminder'
import EstimateRows from '@/components/order/EstimateRows'
import OrderRows from '@/components/order/OrderRows'

export default {
    name: 'Dashboard',
    components: {
        Reminder,
        EstimateRows,
        OrderRows,
    },
    data() {
        return {
            hasReminder: false,
            estimateSearchText: '',
        }
    },
    watch: {
    },
    methods: {
        async checkReminder() {
            if(!this.$store.getters.getAccessToken){
                return
            }
            await this.$store.dispatch('getReminders')
            const reminders = await this.$store.getters.getReminders
            if(reminders.length > 0){
                this.hasReminder = true
            }else{
                this.hasReminder = false
            }
        }
    },
    beforeCreate: function() {

        if(!this.$store.getters.getAccessToken){
            this.$router.push('/user/login')
            return false
        }

    },
    mounted: function() {
        setTimeout(this.checkReminder, 1)
        setInterval(this.checkReminder, this.$store.getters.getCommonRefreshInterval)
    }
}
</script>